import http from 'lib/utils/axios';

const PARTNER_URL = '/partner/';

export const fetch = () => http.get(PARTNER_URL);
export const fetchPartners = (projectId) => http.get(`${PARTNER_URL}${projectId}`);
export const update = ({ parentProjectId }) => http.put(PARTNER_URL, { parentProjectId });
export const disable = projectId => http.post(`${PARTNER_URL}disable/${projectId}`);
export const changeRate = ({ rate, parentProjectId }) => http.put(`${PARTNER_URL}rate/${parentProjectId}`, { rate });
export const fetchReport = publicId => http.get(`${PARTNER_URL}report/${publicId}`);
export const checkPartnerKey = partnerKey => http.get(`${PARTNER_URL}check-partner-key/${partnerKey}`);

export default {
  fetch,
  fetchPartners,
  update,
  disable,
  changeRate,
  fetchReport,
  checkPartnerKey,
};
